import { makeApiCall } from "../makeApiCall";
import { AdminService_URL } from "../Url";

export const newOrderActions = {
  FETCH_ORDER_DATA_SUCCESS: "FETCH_ORDER_DATA_SUCCESS",
  FETCH_ORDER_DATA_FAILURE: "FETCH_ORDER_DATA_FAILURE",
  CONFIRM_MISSINGMED_DATA_SUCCESS: "CONFIRM_MISSINGMED_DATA_SUCCESS",
  CONFIRM_MISSINGMED_DATA_FAILURE: "CONFIRM_MISSINGMED_DATA_FAILURE",
};

////////////////////////////////////////////////
//? To get order details for coldchain & others
////////////////////////////////////////////////

export function getOrderDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newOrderActions.FETCH_ORDER_DATA_SUCCESS,
      payload: props,
    });
  };
}

export function getOrderDetailsError(error) {
  return {
    type: newOrderActions.FETCH_ORDER_DATA_FAILURE,
    payload: error,
  };
}

export function getOrderDetailsThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${AdminService_URL}/getOrderDetailForPwa?orderId=${props.orderId}&warehouseId=${props.warehouseId}`;
  return makeApiCall(
    getUrl,
    getOrderDetailsSuccess,
    getOrderDetailsError,
    "GET",
    null,
    reqHeader,
    props.history
  );
}

////////////////////////////////////////////////
//? Submit Missing med details
////////////////////////////////////////////////

export function confirmMissingMedSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newOrderActions.CONFIRM_MISSINGMED_DATA_SUCCESS,
      payload: props,
    });
  };
}

export function confirmMissingMedError(error) {
  return {
    type: newOrderActions.CONFIRM_MISSINGMED_DATA_FAILURE,
    payload: error,
  };
}

export function confirmMissingMedThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${AdminService_URL}/confirmMissingMedicineDetails?orderId=${props.orderId}&warehouseId=${props.warehouseId}`;
  return makeApiCall(
    getUrl,
    confirmMissingMedSuccess,
    confirmMissingMedError,
    "POST",
    null,
    reqHeader,
    props.history
  );
}
